var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('el-row',[_c('el-col',{attrs:{"span":18,"offset":3}},[_c('h3',{staticClass:"buy-title"},[_vm._v("\n        我的余额\n        ")]),_c('info',{attrs:{"balance":_vm.balance}}),_c('recharge',{attrs:{"title":"充值中心"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }